import React from 'react'

function SubAdminPanel() {
  return (
    <div>sub-adminPanel</div>
  )
}

export default SubAdminPanel